import React from "react";
import Button from "./Button";

// const list = [];
const ButtonList = () => {
  return (
    <div className="flex overflow-hidden justify-center">
      <Button name="All" />
      <Button name="Gaming" />
      <Button name="Songs" />
      <Button name="Football" />
      <Button name="News" />
      <Button name="Cooking" />
      <Button name="Cricket" />
      <Button name="Standup" />
      <Button name="Cooking" />
      <Button name="Cricket" />
      <Button name="Standup" />
      <Button name="Cooking" />
      <Button name="Cricket" />
      
    </div>
  );
};

export default ButtonList;
